import $ from 'jquery';
import 'select2';

const defaults = {
  selector: undefined,
  placeholder: 'Select',
  options: 'ul.links',
  optionSrc: '.link:not(.link-read-more)',
  remove: true,
};

function SelectBox(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.create();
}

SelectBox.prototype = {
  create() {
    const { selector } = this.settings;
    const $links = (selector) ? this.$element.find(`${selector}`) : this.$element;
    const $select = $(`<select class="select2-hidden" data-placeholder="${this.settings.placeholder}"></select>`);
    const $list = $links.find(this.settings.options);
    const $options = $list.find(this.settings.optionSrc);
    $select.append(`<option selected disabled value="0">${this.settings.placeholder}</option>`);
    $options.each((i, item) => {
      const label = $(item).text();
      const value = $('a', item).attr('href');
      const option = `<option value="${value}">${label}</option>`;
      $select.append(option);
    });
    $select.insertBefore($list);
    $select.select2();
    if (this.settings.selector === '.node-links' && this.settings.remove) {
      $list.hide(); // if .node-links is removed, node flyout is broken
    } else if (this.settings.selector !== '.node-links') {
      $list.remove();
    }
    // Add an on selection change event handler which redirects users to the
    // selected program.
    $select.on('select2:select', (event) => {
      const { data } = event.params;
      if (data && data.id) {
        window.open(data.id, '_self');
      }
    });
    // Add ready class to fade it in.
    $links.addClass('ready');
  },
};

export default SelectBox;
